import React from 'react';
import Image from '../../../image/Image';
import './NameWithIcon.scss';

const NameWithIcon = ({
    icon,
    name,
}: {
    icon: string,
    name: string,
}) => {
    return (
        <div className="nameWithIcon">
            {icon && (
                <Image src={icon} alt={name} className="nameWithIcon_icon"/>
            )}
            <span title={name}>{name}</span>
        </div>
    );
};

export default NameWithIcon;